import { render, staticRenderFns } from "./ConnectStateroomItem.vue?vue&type=template&id=b1aebd02&scoped=true"
import script from "./ConnectStateroomItem.vue?vue&type=script&lang=js"
export * from "./ConnectStateroomItem.vue?vue&type=script&lang=js"
import style0 from "./ConnectStateroomItem.vue?vue&type=style&index=0&id=b1aebd02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1aebd02",
  null
  
)

export default component.exports